import { render, staticRenderFns } from "./TerminosView.vue?vue&type=template&id=9b095ce0"
import script from "./TerminosView.vue?vue&type=script&lang=js"
export * from "./TerminosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports